import { createApp } from "vue";
import { store } from "./store";
// normalize.css
import "normalize.css/normalize.css";
// 全局样式
import "./styles/index.less";
// svg icon
import "virtual:svg-icons-register";
import App from "./App.vue";
import router from "./router";
import "uno.css";
import "animate.css";
import "./utils/vconsole";
import "shepherd.js/dist/css/shepherd.css";
import { init } from "@umengfe/apm";
import "./utils/rewrite-global-error";
if (import.meta.env.PROD) {
  // 由于开发环境全局导入vant样式会导致控制台卡顿，但由于历史缘故，构建环境还是需要全局导入vant样式
  import("vant/lib/index.css");
}

// 生成环境启动
if (import.meta.env.MODE === "production") {
  init({
    pageFilter: { mode: "ignore", rules: [] },
    pid: "692e95a88560e34872f93035"
  });
}

const app = createApp(App);

app.use(store);
app.use(router);

app.mount("#app");
